// Auto-generated from AWS top100 resources whitelist
export const awsIconsByTypeTop100: Record<string, string> = {
  // Compute
  aws_instance: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_autoscaling_group: "/icons/aws/Arch_Amazon-EC2-Auto-Scaling_64.svg",
  aws_launch_template: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_lambda_function: "/icons/aws/Arch_AWS-Lambda_64.svg",
  aws_ecs_cluster: "/icons/aws/Arch_Amazon-Elastic-Container-Service_64.svg",
  aws_ecs_service: "/icons/aws/Arch_Amazon-Elastic-Container-Service_64.svg",
  aws_ecs_task_definition: "/icons/aws/Arch_Amazon-Elastic-Container-Service_64.svg",
  aws_eks_cluster: "/icons/aws/Arch_Amazon-Elastic-Kubernetes-Service_64.svg",
  aws_eks_node_group: "/icons/aws/Arch_Amazon-Elastic-Kubernetes-Service_64.svg",
  aws_elastic_beanstalk_application: "/icons/aws/Arch_AWS-Elastic-Beanstalk_64.svg",
  aws_elastic_beanstalk_environment: "/icons/aws/Arch_AWS-Elastic-Beanstalk_64.svg",
  aws_batch_compute_environment: "/icons/aws/Arch_AWS-Batch_64.svg",
  aws_batch_job_definition: "/icons/aws/Arch_AWS-Batch_64.svg",
  aws_batch_job_queue: "/icons/aws/Arch_AWS-Batch_64.svg",

  // Storage
  aws_s3_bucket: "/icons/aws/Arch_Amazon-Simple-Storage-Service_64.svg",
  aws_s3_bucket_policy: "/icons/aws/Arch_Amazon-Simple-Storage-Service_64.svg",
  aws_s3_bucket_public_access_block: "/icons/aws/Arch_Amazon-Simple-Storage-Service_64.svg",
  aws_s3_object: "/icons/aws/Arch_Amazon-Simple-Storage-Service_64.svg",
  aws_ebs_volume: "/icons/aws/Arch_Amazon-Elastic-Block-Store_64.svg",
  aws_ebs_snapshot: "/icons/aws/Arch_Amazon-Elastic-Block-Store_64.svg",
  aws_efs_file_system: "/icons/aws/Arch_Amazon-Elastic-File-System_64.svg",
  aws_efs_mount_target: "/icons/aws/Arch_Amazon-Elastic-File-System_64.svg",
  aws_fsx_windows_file_system: "/icons/aws/Arch_Amazon-FSx-for-Windows-File-Server_64.svg",
  aws_fsx_lustre_file_system: "/icons/aws/Arch_Amazon-FSx-for-Lustre_64.svg",
  aws_glacier_vault: "/icons/aws/Arch_Amazon-Simple-Storage-Service-Glacier_64.svg",

  // Database
  aws_db_instance: "/icons/aws/Arch_Amazon-RDS_64.svg",
  aws_db_subnet_group: "/icons/aws/Arch_Amazon-RDS_64.svg",
  aws_db_parameter_group: "/icons/aws/Arch_Amazon-RDS_64.svg",
  aws_rds_cluster: "/icons/aws/Arch_Amazon-Aurora_64.svg",
  aws_rds_cluster_instance: "/icons/aws/Arch_Amazon-Aurora_64.svg",
  aws_dynamodb_table: "/icons/aws/Arch_Amazon-DynamoDB_64.svg",
  aws_elasticache_cluster: "/icons/aws/Arch_Amazon-ElastiCache_64.svg",
  aws_elasticache_replication_group: "/icons/aws/Arch_Amazon-ElastiCache_64.svg",
  aws_redshift_cluster: "/icons/aws/Arch_Amazon-RDS_64.svg",
  aws_neptune_cluster: "/icons/aws/Arch_Amazon-Neptune_64.svg",
  aws_docdb_cluster: "/icons/aws/Arch_Amazon-DocumentDB_64.svg",
  aws_docdb_cluster_instance: "/icons/aws/Arch_Amazon-DocumentDB_64.svg",

  // Networking
  aws_vpc: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_subnet: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_internet_gateway: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_nat_gateway: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_route_table: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_route_table_association: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_security_group: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_security_group_rule: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_network_acl: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_network_interface: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_eip: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_vpc_peering_connection: "/icons/aws/Arch_Amazon-Virtual-Private-Cloud_64.svg",
  aws_vpn_gateway: "/icons/aws/Arch_AWS-Site-to-Site-VPN_64.svg",
  aws_vpn_connection: "/icons/aws/Arch_AWS-Site-to-Site-VPN_64.svg",
  aws_customer_gateway: "/icons/aws/Arch_AWS-Site-to-Site-VPN_64.svg",
  aws_route53_zone: "/icons/aws/Arch_Amazon-Route-53_64.svg",
  aws_route53_record: "/icons/aws/Arch_Amazon-Route-53_64.svg",
  aws_cloudfront_distribution: "/icons/aws/Arch_Amazon-CloudFront_64.svg",
  aws_elb: "/icons/aws/Arch_Elastic-Load-Balancing_64.svg",
  aws_lb: "/icons/aws/Arch_Elastic-Load-Balancing_64.svg",
  aws_lb_target_group: "/icons/aws/Arch_Elastic-Load-Balancing_64.svg",
  aws_lb_listener: "/icons/aws/Arch_Elastic-Load-Balancing_64.svg",
  aws_api_gateway_rest_api: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_api_gateway_resource: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_api_gateway_method: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_api_gateway_deployment: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_apigatewayv2_api: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_apigatewayv2_stage: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_direct_connect_gateway: "/icons/aws/Arch_AWS-Direct-Connect_64.svg",
  aws_vpc_endpoint: "/icons/aws/Arch_AWS-PrivateLink_64.svg",

  // Security
  aws_iam_role: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_iam_role_policy: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_iam_policy: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_iam_policy_attachment: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_iam_user: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_iam_group: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_iam_access_key: "/icons/aws/Arch_AWS-Identity-and-Access-Management_64.svg",
  aws_kms_key: "/icons/aws/Arch_AWS-Key-Management-Service_64.svg",
  aws_kms_alias: "/icons/aws/Arch_AWS-Key-Management-Service_64.svg",
  aws_secretsmanager_secret: "/icons/aws/Arch_AWS-Secrets-Manager_64.svg",
  aws_secretsmanager_secret_version: "/icons/aws/Arch_AWS-Secrets-Manager_64.svg",
  aws_acm_certificate: "/icons/aws/Arch_AWS-Certificate-Manager_64.svg",
  aws_cognito_user_pool: "/icons/aws/Arch_Amazon-Cognito_64.svg",
  aws_cognito_identity_pool: "/icons/aws/Arch_Amazon-Cognito_64.svg",
  aws_waf_web_acl: "/icons/aws/Arch_AWS-WAF_64.svg",
  aws_wafv2_web_acl: "/icons/aws/Arch_AWS-WAF_64.svg",
  aws_guardduty_detector: "/icons/aws/Arch_Amazon-GuardDuty_64.svg",
  aws_security_hub_account: "/icons/aws/Arch_AWS-Security-Hub_64.svg",

  // Analytics
  aws_kinesis_stream: "/icons/aws/Arch_Amazon-Kinesis-Video-Streams_64.svg",
  aws_kinesis_firehose_delivery_stream: "/icons/aws/Arch_Amazon-Kinesis-Video-Streams_64.svg",
  aws_glue_catalog_database: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_glue_crawler: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_athena_database: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_athena_workgroup: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_emr_cluster: "/icons/aws/Arch_Amazon-EC2_64.svg",

  // DevOps
  aws_codepipeline: "/icons/aws/Arch_AWS-CodePipeline_64.svg",
  aws_codebuild_project: "/icons/aws/Arch_AWS-CodeBuild_64.svg",
  aws_codecommit_repository: "/icons/aws/Arch_AWS-CodeCommit_64.svg",
  aws_codedeploy_app: "/icons/aws/Arch_AWS-CodeDeploy_64.svg",
  aws_codedeploy_deployment_group: "/icons/aws/Arch_AWS-CodeDeploy_64.svg",
  aws_ecr_repository: "/icons/aws/Arch_Amazon-Elastic-Container-Registry_64.svg",

  // Monitoring
  aws_cloudwatch_log_group: "/icons/aws/Arch_Amazon-CloudWatch_64.svg",
  aws_cloudwatch_log_stream: "/icons/aws/Arch_Amazon-CloudWatch_64.svg",
  aws_cloudwatch_metric_alarm: "/icons/aws/Arch_Amazon-CloudWatch_64.svg",
  aws_cloudwatch_dashboard: "/icons/aws/Arch_Amazon-CloudWatch_64.svg",
  aws_sns_topic: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_sns_topic_subscription: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_sqs_queue: "/icons/aws/Arch_Amazon-EC2_64.svg",
  aws_cloudtrail: "/icons/aws/Arch_AWS-CloudTrail_64.svg",

  // AI/ML
  aws_sagemaker_notebook_instance: "/icons/aws/Arch_Amazon-SageMaker_64.svg",
  aws_sagemaker_model: "/icons/aws/Arch_Amazon-SageMaker_64.svg",
  aws_sagemaker_endpoint: "/icons/aws/Arch_Amazon-SageMaker_64.svg",
  aws_sagemaker_endpoint_configuration: "/icons/aws/Arch_Amazon-SageMaker_64.svg",

  // Other
  aws_ssm_parameter: "/icons/aws/Arch_AWS-Systems-Manager_64.svg",
  aws_backup_vault: "/icons/aws/Arch_AWS-Backup_64.svg",
  aws_backup_plan: "/icons/aws/Arch_AWS-Backup_64.svg",
  aws_config_configuration_recorder: "/icons/aws/Arch_AWS-Config_64.svg",
  aws_cloudformation_stack: "/icons/aws/Arch_AWS-CloudFormation_64.svg",
};
